import { findKey } from "lodash";
import { isClient } from "common/helper";
import { cleanEnv, str } from "envalid";

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str({ default: "0.0.0.0" }),
  REACT_APP_DEFAULT_LANG: str({ default: "th" }),
  NODE_ENV: str({ default: "development" }),
});

const config = {
  production: {
    HOST: "https://eclaim-backoffice.zennite.co",
    API_ENDPOINT: "https://eclaim-api.zennite.co/graphql",
    API: "https://eclaim-api.zennite.co",
    BACKOFFICE_ENDPOINT: "https://eclaim-backoffice.zennite.co",
    APP_ENDPOINT: "https://eclaim.zennite.co",
  },
  demo: {
    HOST: "https://eclaim-backoffice.demo.zennite.co",
    API_ENDPOINT: "https://eclaim-api.demo.zennite.co/graphql",
    API: "https://eclaim-api.demo.zennite.co",
    BACKOFFICE_ENDPOINT: "https://eclaim-backoffice.demo.zennite.co",
    APP_ENDPOINT: "https://eclaim.demo.zennite.co",
  },
  uat: {
    HOST: "https://eclaim-backoffice.uat.zennite.co",
    API_ENDPOINT: "https://eclaim-api.uat.zennite.co/graphql",
    API: "https://eclaim-api.uat.zennite.co",
    BACKOFFICE_ENDPOINT: "https://eclaim-backoffice.uat.zennite.co",
    APP_ENDPOINT: "https://eclaim.uat.zennite.co",
  },
  staging: {
    HOST: "https://dev.backoffice.bam.ldrive.io",
    API_ENDPOINT: "https://dev.backoffice.bam.ldrive.io/graphql",
    API: "https://dev.api.bam.ldrive.io",
    BACKOFFICE_ENDPOINT: "https://dev.backoffice.bam.ldrive.io",
    APP_ENDPOINT: "https://dev.app.bam.ldrive.io",
  },
  development: {
    HOST: "http://localhost:21802",
    API_ENDPOINT: "http://localhost:21801/graphql",
    API: "http://localhost:21801",
    BACKOFFICE_ENDPOINT: "http://localhost:21802",
    APP_ENDPOINT: "http://localhost:21803",
  },
};

export const getEnvByHost = () =>
  isClient ? findKey(config, { HOST: window.location.origin }) : null;

export const nodeEnv = getEnvByHost() || "production";

console.log("HOST : ", getEnvByHost());

const appEnvConfig = {
  production: {
    HOST: "https://eclaim.zennite.co",
    API_ENDPOINT: "https://eclaim-api.zennite.co/graphql",
    API: "https://eclaim-api.zennite.co",
  },
  demo: {
    HOST: "https://eclaim.demo.zennite.co",
    API_ENDPOINT: "https://eclaim-api.demo.zennite.co/graphql",
    API: "https://eclaim-api.demo.zennite.co",
  },
  uat: {
    HOST: "https://eclaim.uat.zennite.co",
    API_ENDPOINT: "https://eclaim-api.uat.zennite.co/graphql",
    API: "https://eclaim-api.uat.zennite.co",
  },
  staging: {
    HOST: "https://dev.app.bam.ldrive.io",
    API_ENDPOINT: "https://dev.app.bam.ldrive.io/graphql",
    API: "https://dev.api.bam.ldrive.io",
  },
  development: {
    HOST: "http://localhost:21803",
    API_ENDPOINT: "http://localhost:21801/graphql",
    API: "http://localhost:21801",
  },
};

const MOCK_MSAL_CONFIG = {
  production: {
    REACT_APP_MSAL_CLIENT_ID: "dedc3516-f81f-48df-92d2-b5147ee13811",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://eclaim-backoffice.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://eclaim-backoffice.zennite.co",
  },
  demo: {
    REACT_APP_MSAL_CLIENT_ID: "dedc3516-f81f-48df-92d2-b5147ee13811",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://eclaim-backoffice.demo.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://eclaim-backoffice.demo.zennite.co",
  },
  uat: {
    REACT_APP_MSAL_CLIENT_ID: "dedc3516-f81f-48df-92d2-b5147ee13811",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://eclaim-backoffice.uat.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://eclaim-backoffice.uat.zennite.co",
  },
  staging: {
    REACT_APP_MSAL_CLIENT_ID: "dedc3516-f81f-48df-92d2-b5147ee13811",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://dev.backoffice.bam.ldrive.io",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://dev.backoffice.bam.ldrive.io",
  },
  development: {
    REACT_APP_MSAL_CLIENT_ID: "dedc3516-f81f-48df-92d2-b5147ee13811",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "http://localhost:21802",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "http://localhost:21802",
  },
};

export const appEnv = appEnvConfig[nodeEnv];

const env = {
  ...config[nodeEnv],
  ...MOCK_MSAL_CONFIG[nodeEnv],
};

console.log("ENV : ", env);
export default env;
